import React from 'react';
import moment from 'moment/moment';
import { Box, Stack, Typography } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

interface Props {
  canWrite: boolean;
  dateValidationError: boolean;
  lastDateAvailable: string | null;
  firstDateAvailable: string | null;
  setDateValidationError: (value: boolean) => void;
  setLastDateAvailable: (value: string | null) => void;
  setFirstDateAvailable: (value: string | null) => void;
  validateDates: (first: string | null, last: string | null) => boolean;
}

export const AvailabilitySection = ({
  canWrite,
  validateDates,
  lastDateAvailable,
  firstDateAvailable,
  dateValidationError,
  setLastDateAvailable,
  setFirstDateAvailable,
  setDateValidationError,
}: Props) => {
  return (
    <Stack gap="0.5rem">
      <Typography variant="subtitle2" component="span">
        Product Availability (Optional)
      </Typography>

      <Box display="flex" gap="1rem" flexWrap="wrap">
        <Box flex="1" minWidth="200px">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="First Date Available"
              value={firstDateAvailable ? moment(firstDateAvailable) : null}
              onChange={date => {
                const newDate = date ? date.format() : null;
                setFirstDateAvailable(newDate);
                setDateValidationError(validateDates(newDate, lastDateAvailable));
              }}
              disabled={!canWrite}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                  variant: 'outlined',
                  error: dateValidationError,
                },
              }}
            />
          </LocalizationProvider>
        </Box>

        <Box flex="1" minWidth="200px">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Last Date Available"
              value={lastDateAvailable ? moment(lastDateAvailable) : null}
              onChange={date => {
                const newDate = date ? date.endOf('day').format() : null;
                setLastDateAvailable(newDate);
                setDateValidationError(validateDates(firstDateAvailable, newDate));
              }}
              disabled={!canWrite}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                  variant: 'outlined',
                  error: dateValidationError,
                  helperText: dateValidationError ? 'Last date must be after first date' : '',
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Box>
    </Stack>
  );
};
